import { I18n } from '@calendly/i18n'

import { isNotetakerEligibleLocationKind } from 'features/growth_experiments'
import { getPoolingTypeKinds } from 'services/event_types'

export const getMembershipKey = (membership) => `${membership.type}-${membership.user_id || membership.organization_invitation_id}`

const emptyArray = []
export const getUserPools = (values) => values.user_pools || values.userPools || emptyArray

export const getIsAnyCollectiveUserPools = (userPools) => {
  if (!userPools || userPools.length === 0) return false

  return userPools.some((pool) => !pool._destroy
      && (pool.pooling_type === 'collective' || pool.poolingType === 'collective')
  )
}

export const getIsRROrCRRWithoutCollectivePools = (isRoundRobin, isCollectiveRoundRobin, userPools) => {
  const isAnyCollectiveUserPools = getIsAnyCollectiveUserPools(userPools)
  return isRoundRobin || (isCollectiveRoundRobin && !isAnyCollectiveUserPools)
}

// i18n-tasks-use t("publisher.event_type_editor.sections.event_details.location.dropdown.ask_invitee.label")
// i18n-tasks-use t("publisher.event_type_editor.sections.event_details.location.dropdown.custom.label")
// i18n-tasks-use t("publisher.event_type_editor.sections.event_details.location.dropdown.google_conference.label")
// i18n-tasks-use t("publisher.event_type_editor.sections.event_details.location.dropdown.gotomeeting_conference.label")
// i18n-tasks-use t("publisher.event_type_editor.sections.event_details.location.dropdown.inbound_call.label")
// i18n-tasks-use t("publisher.event_type_editor.sections.event_details.location.dropdown.microsoft_teams_conference.label")
// i18n-tasks-use t("publisher.event_type_editor.sections.event_details.location.dropdown.outbound_call.label")
// i18n-tasks-use t("publisher.event_type_editor.sections.event_details.location.dropdown.physical.label")
// i18n-tasks-use t("publisher.event_type_editor.sections.event_details.location.dropdown.webex_conference.label")
// i18n-tasks-use t("publisher.event_type_editor.sections.event_details.location.dropdown.zoom_conference.label")
export const getLabelForKind = (kind) => {
  if (kind === 'all_options') {
    return I18n.t('publisher.event_type_editor.sections.event_details.fields.location.dropdown.label')
  }
  return I18n.t(`publisher.event_type_editor.sections.event_details.location.dropdown.${kind}.label`)
}

export const determinePreviewCardLocationFields = (formValues) => {
  const { pooling_type: poolingType, user_pools: userPools } = formValues
  const { isRoundRobin, isCollectiveRoundRobin } = getPoolingTypeKinds(poolingType)
  const isLocationOnMemberships = getIsRROrCRRWithoutCollectivePools(isRoundRobin, isCollectiveRoundRobin, userPools)

  if (isLocationOnMemberships) {
    return { location_types_count: null, location_type: null }
  }

  const notDeletedLocations = (formValues.locationConfigurations || []).filter(({ _destroy }) => !_destroy)

  return {
    location_types_count: notDeletedLocations.length,
    location_type: notDeletedLocations[0]?.kind || null
  }
}

const INFO_ATTRIBUTE_FOR_KIND = {
  custom: 'location',
  physical: 'location',
  inbound_call: 'phone_number'
}

const withNotetakerOnSuffix = ({ kind, label, isNotetakerEnabledForEt, hasMsTeamsFlag = false }) => {
  if (!isNotetakerEnabledForEt || !isNotetakerEligibleLocationKind(kind, hasMsTeamsFlag)) return label

  return I18n.t(
    'publisher.event_type_editor.sections.event_details.location.notetaker_toggle.location_on_suffix',
    { location_name: label }
  )
}

export const getLabelForKindWithNotetaker = ({ kind, isNotetakerEnabledForEt = false, hasMsTeamsFlag = false }) => {
  const baseLabel = getLabelForKind(kind)
  return withNotetakerOnSuffix({ kind, label: baseLabel, isNotetakerEnabledForEt, hasMsTeamsFlag })
}

export const infoForLocation = (location, { isNotetakerEnabledForEt = false, hasMsTeamsFlag = false } = {}) => {
  const defaultInfo = I18n.t(`publisher.event_types.location.${location.kind}.label`)
  const baseInfo = location[INFO_ATTRIBUTE_FOR_KIND[location.kind]] || defaultInfo

  return withNotetakerOnSuffix({
    kind: location.kind,
    label: baseInfo,
    isNotetakerEnabledForEt,
    hasMsTeamsFlag
  })
}
